export enum ModalIdentifierKey {
  UPDATE_PASSWORD_MODAL = 'updatePasswordModal',
  UPDATE_REGISTERED_EMAIL_MODAL = 'updateRegisteredEmailModal',
  UPDATE_PERSONAL_INFO_MODAL = 'updatePersonalInfoModal',
  RECOVER_PASSWORD_MODAL = 'recoverPasswordModal',
  UPDATE_CONFIRMATION_EMAIL_MODAL = 'updateConfirmationEmailModal',
  LOGO_CROP_MODAL = 'logoCropModal',
  DELETE_LOGO_CONFIRMATION_MODAL = 'deleteLogoConfirmationModal',
  DELETE_SERIE_CONFIRMATION_MODAL = 'deleteSerieConfirmationModal',
  DELETE_CLIENT_CONFIRMATION_MODAL = 'deleteClientConfirmationModal',
  EXPORT_CLIENTS_MODAL = 'exportClientsModal',
  TAX_GROUP_FORM_MODAL = 'taxGroupFormModal',
  TAX_GROUP_DELETE_CONFIRMATION_MODAL = 'taxGroupDeleteConfirmationModal',
  TAX_GROUP_PRESETS_MODAL = 'taxGroupPresetsModal',
  PRODUCT_SERVICE_EXPORT_MODAL = 'productServiceExportModal',
  PRODUCT_SERVICE_DELETE_CONFIRMATION_MODAL = 'productServiceDeleteConfirmationModal',
  CLIENT_MODAL = 'clientModal',
  PRODUCT_SERVICE_MODAL = 'productServiceModal',
  PRE_FACTURA_DELETE_CONFIRMATION_MODAL = 'preFacturaDeleteConfirmationModal',
  CANCEL_COMPROBANTE_MODAL = 'cancelComprobanteModal',
  CANCEL_COMPROBANTE_PAGO_MODAL = 'cancelComprobantePagoModal',
  SEND_SHARE_MODAL = 'sendShareModal',
  SEND_SHARE_PAGO_MODAL = 'sendSharePagoModal',
  SEND_HISTORY_MODAL = 'sendHistoryModal',
  SEND_HISTORY_PAGO_MODAL = 'sendHistoryPagoModal',
  TIMBRAR_PRE_FACTURA_CONFIRMATION_MODAL = 'timbrarPreFacturaConfirmationModal',
  TIMBRAR_PRE_FACTURA_EXPIRED_CONFIRMATION_MODAL = 'timbrarPreFacturaExpiredConfirmationModal',
  RECEPCION_PAGO_MODAL = 'recepcionPagoModal',
  RECEPCION_PAGO_PENDING_PAYMENTS_MODAL = 'recepcionPagoPendingPaymentsModal',
  CONFIRM_TIMBRAR_FACTURA_GLOBAL_MES_ACTUAL_MODAL = 'confirmTimbrarFacturaGlobalMesActualModal',
  PWA_INSTALL_INSTRUCTIONS_MODAL = 'pwaInstallInstructionsModal',
}
